module.exports = __webpack_public_path__ + "img/4.35168ceb.jpg";